"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConstantType = exports.sourceOfCollection = void 0;
var externalApi_1 = require("./externalApi");
var plugins_1 = require("./plugins");
var DEFAULT = 'DEFAULT';
exports.sourceOfCollection = [DEFAULT, externalApi_1.XANO, externalApi_1.SUPABASE, externalApi_1.AIRTABLE, plugins_1.pluginCode.FIREBASE, plugins_1.pluginCode.FIRESTORE, externalApi_1.NOTION, externalApi_1.APP_WRITE, externalApi_1.DIRECTUS, externalApi_1.XATA, externalApi_1.SALESFORCE];
exports.ConstantType = ['DATE', 'BOOLEAN', 'STRING', 'NUMBER', 'LIST', 'EMAIL'];